export const getTerminalErrorMessage = (error, fallback = 'Something went wrong.') => {
  const detail = error?.response?.data?.detail;
  if (typeof detail === 'string' && detail.trim()) return detail;
  if (typeof error?.message === 'string' && error.message.trim() && error.message !== 'Network Error') return error.message;
  return fallback;
};

export const parseTerminalServerMessage = (value) => {
  try {
    const payload = JSON.parse(value);
    if (payload?.type === 'error') {
      return { type: 'error', message: payload.message || payload.detail || 'The terminal reported an error.' };
    }
    if (payload?.type === 'status') {
      const defaultMessage = payload.state === 'connected'
        ? 'Secure session connected.'
        : payload.state === 'connecting'
          ? 'Verifying server identity and opening SSH…'
          : 'Terminal status updated.';
      return { type: 'status', state: payload.state, message: payload.message || payload.status || defaultMessage };
    }
    if (payload?.type === 'output' && typeof payload.data === 'string') {
      return { type: 'output', data: payload.data };
    }
    return { type: 'status', message: 'Terminal status updated.' };
  } catch (error) {
    return { type: 'output', data: value };
  }
};

export const terminalUnavailablePresentation = (access = {}) => {
  const currentAccess = access || {};
  const presentations = {
    operator_disabled: {
      title: 'Terminal access is turned off',
      detail: 'An administrator has disabled terminal sessions for this environment. Inventory, power controls, and retirement are unaffected.',
      retryable: false,
    },
    unsupported: { title: 'Terminal not supported', detail: 'Browser terminal access is available only for servers.', retryable: false },
    missing_host: { title: 'Server address missing', detail: 'Add a public server address in Context before opening a terminal.', retryable: false },
    grant_required: { title: 'Terminal grant required', detail: 'You need an active terminal access grant for this server.', retryable: false },
    personal_ssh_identity_required: { title: 'Personal SSH identity required', detail: 'Create your personal SSH identity before opening a browser terminal.', retryable: false },
    credential_mode_disabled: { title: 'Secure credentials are turned off', detail: 'An administrator has disabled browser terminal credentials for this environment.', retryable: false },
    jit_prerequisites_disabled: { title: 'Terminal setup is incomplete', detail: 'The short-lived terminal access services are not fully enabled.', retryable: false },
  };
  return presentations[currentAccess.state] || {
    title: 'Terminal unavailable',
    detail: currentAccess.reason || 'Terminal readiness could not be confirmed.',
    retryable: true,
  };
};
